<template>
  <v-flex xs2 md4>
    <strong>{{ title }}</strong>
    <br>
    <span v-if="detail.type === 'amount'">
      {{ detail.value | formatNumber }}
    </span>
    <span v-else-if="detail.type === 'date'">
      {{ detail.value | formatDate }}
    </span>
    <span v-else>
      {{ detail.value }}
    </span>
  </v-flex>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        default: '',
      },
      detail: {
        type: Object,
        default: () => ({}),
      },
    },
    filters: {
      formatDate(date) {
        return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
      },
      formatNumber(value) {
        return new Intl.NumberFormat('es-VE', {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }).format(value);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/customer/DueDetail.vue